// ============================================================================
// AUDIT SERVICE — Personal Finance V2 (Blueprint §6.3)
// Log append-only de transições de status. Imutável após escrita.
// ============================================================================

import { appendAuditLog } from '../ports/firestoreRepo.js';

/**
 * Registra uma transição no audit log.
 * @param {{ postingId: string, pairId?: string, action: string, before?: object, after?: object, reason?: string, actor?: string }} entry
 */
export async function logTransition({ postingId, pairId = null, action, before = null, after = null, reason = null, actor = 'rodrigo' }) {
    await appendAuditLog([{
        postingId,
        pairId,
        action,
        before,
        after,
        reason,
        actor,
    }]);
}

/**
 * Registra transições para ambos os lados de um par.
 */
export async function logPairTransition({ pairId, expenseId, incomeId, action, before = null, after = null, reason = null, actor = 'rodrigo' }) {
    await appendAuditLog([
        { postingId: expenseId, pairId, action, before, after, reason, actor },
        { postingId: incomeId, pairId, action, before, after, reason, actor },
    ]);
}
